import { LinkField, TStringField } from '../../../types/types';
import { TNewsFilesFields, TNewsFilesProps, TNewsItemsData } from '../types/newsFiles.types';

export class NewsFilesModel {
  private readonly fields: TNewsFilesFields;

  constructor(props: TNewsFilesProps) {
    this.fields = props.fields;
  }

  get title(): TStringField {
    return this.fields?.title;
  }

  get eyebrow(): TStringField {
    return this.fields?.eyebrow;
  }

  get downloadNewsFilesCard(): TNewsItemsData[] {
    return (this.fields.items || []).map((item, index) => ({
      fileName: item?.fields?.fileName,
      fileSize: item?.fields?.fileSize,
      thumbnailLink: item?.fields?.thumbnailLink,
      fileLink: item?.fields?.fileLink,
      id: item?.fields?.id,
      active: item?.fields?.active,
      componentNumber: index + 1,
    }));
  }

  get downloadFileCardLength(): number {
    return this.downloadNewsFilesCard.length;
  }

  get optionalCTA(): LinkField | undefined {
    return this.fields?.primaryLink;
  }

  get isUnreleased(): boolean {
    return !!this.fields?.isComponentUnreleased;
  }
}
